// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scrollbar[data-v-46d6e2a5]::-webkit-scrollbar{width:8px}.scrollbar[data-v-46d6e2a5]::-webkit-scrollbar-thumb{border-radius:8px;height:75px}.input-select[data-v-46d6e2a5]{-webkit-tap-highlight-color:rgba(0,0,0,0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
